import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SEO from '../../../components/SEO/SEO';

import { puctures } from '../../../assets/images';

const OnboardingOffboarding: React.FC = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="Onboarding & Offboarding Consulting Boston MA"
        description="Employee onboarding & offboarding consulting — streamlined processes, lifecycle management, and retention strategies by ERHR Global."
        url="https://erhrglobal.com/strategic-hr/onboarding-offboarding"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Onboarding & Offboarding Consulting in Boston",
          "description": "Employee onboarding and offboarding strategy and management consulting for businesses in Boston, Massachusetts.",
          "url": "https://erhrglobal.com/strategic-hr/onboarding-offboarding",
          "provider": {"@type": "ProfessionalService", "name": "ERHR Global", "address": {"@type": "PostalAddress", "addressLocality": "Boston", "addressRegion": "MA", "addressCountry": "US"}},
          "areaServed": [{"@type": "City", "name": "Boston"}, {"@type": "State", "name": "Massachusetts"}]
        }}
      />
      <section className="bg-gradient-to-br from-primary-600 to-primary-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <h1 className="text-4xl lg:text-5xl font-bold mb-6">Onboarding & Offboarding Strategy & Management</h1>
            <p className="text-xl text-primary-100 max-w-3xl mx-auto">
            Is your onboarding and offboarding process delivering the experience, consistency, and compliance your organization needs—or is it costing you time, talent, and insight?
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl font-bold text-gray-900 mb-6">First Impressions & Lasting Connections</h2>
              <p className="text-lg text-gray-600 mb-6">
                The employee journey begins before their first day and continues even after they leave. Effective onboarding accelerates time-to-productivity and increases retention, while thoughtful offboarding protects your organization and maintains positive relationships.
              </p>
              <p className="text-lg text-gray-600 mb-6">
              At ERHR Global, we specialize in creating customized onboarding and offboarding experiences tailored to your company’s structure, culture, and workforce needs. We bring strategy, structure, and compliance together — but what truly sets us apart is our human- first approach.
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-gradient-to-br from-primary-50 to-primary-100 rounded-2xl p-8"
            >
              <h3 className="text-2xl font-semibold text-primary-800 mb-6">Our Services Include</h3>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-primary-600 mr-3 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-primary-700">Pre-boarding and day-one experience design</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-primary-600 mr-3 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-primary-700">90-day integration programs</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-primary-600 mr-3 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-primary-700">Exit interview and knowledge transfer processes</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-primary-600 mr-3 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-primary-700">Alumni network and boomerang employee programs</span>
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

        <section className="py-20 bg-gray-100">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                  <div>
                  <motion.div
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    viewport={{ once: true }}
                    className="bg-gradient-to-br from-primary-50 to-primary-100 rounded-2xl p-8"
                  >
                  <h2 className="text-2xl font-semibold text-primary-800 mb-6">Why Partner With Us</h2>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-primary-600 mr-3 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-primary-700">Customized solutions for your company’s size, sector, and culture
                  </span>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-primary-600 mr-3 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-primary-700">Real human support — not just automation or templated flows
                  </span>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-primary-600 mr-3 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-primary-700">Compliance-first design across onboarding and offboarding
                  </span>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-primary-600 mr-3 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-primary-700">IT and system access management
                  </span>
                </li>
              </ul>
                  </motion.div>
                  <Link
                to="/contact"
                className="bg-primary-600 text-white px-8 py-4 text-lg rounded-lg font-semibold text-center hover:bg-primary-700 transition-colors duration-300 inline-block w-full mt-20"
              >
                Optimize Your Employee Journey
              </Link>
                  </div>
                  <motion.div
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                  >
                    <div className="relative mb-8">
                      <img
                        src={puctures.artificalI}
                        alt="Professional HR team"
                        className="w-full h-64 object-cover rounded-2xl"
                        loading="lazy"
                      />
                      <div className="absolute inset-0 bg-primary-600 bg-opacity-20 rounded-2xl"></div>
                    </div>
                    <h2 className="text-3xl font-bold text-gray-900 mb-6">What Makes Us Different
                    </h2>
                    <p className="text-lg text-gray-600 mb-6">
                    The Human Touch in a World of AI
                    </p>
                    <p className="text-lg text-gray-600">
                    In an era where automation and AI dominate the employee lifecycle, we ensure every new hire or exiting employee has real human connection throughout the process. Whether it's orientation, policy walkthroughs, or exit conversations — your employees will always speak with someone, not just a system. We believe people deserve personal attention — not just process automation.</p>
                  </motion.div>
                </div>
              </div>
            </section>

      <section className="py-20 bg-primary-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl font-bold text-white mb-4">Ready to Perfect Your Employee Journey?</h2>
            <p className="text-xl text-primary-100 mb-8 max-w-3xl mx-auto">
              Create onboarding and offboarding experiences that drive engagement, productivity, and positive outcomes.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="bg-white text-primary-700 px-8 py-4 rounded-lg font-semibold hover:bg-primary-50 transition-colors duration-300"
              >
                Get Started
              </Link>
              <Link
                to="/schedule-appointment"
                className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-primary-700 transition-colors duration-300"
              >
                Schedule Consultation
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default OnboardingOffboarding;
